import { SelectingIngredientListDataItem } from "@/types/common";
import { PantryList } from "@/types/pantry";
//
// 買い物リストの型定義
//
export interface RootState {
  version: string;
}

//
// API関係
//

// 買い物リスト取得の一要素
export interface ShoppingListFoodListItem {
  id: number;
  foodId: number;
  name:	string;
  isChecked: boolean;
  hasStock: boolean;
}

export interface ShoppingListUncheckedFoodListItem {
  categoryName: string;
  items: Array<ShoppingListFoodListItem>;
}
export interface ShoppingListCheckedFoodListItem {
  items: Array<ShoppingListFoodListItem>;
}
export class ShoppingListFoodList {
  uncheckedFoods: Array<ShoppingListUncheckedFoodListItem>;
  checkedFoods: Array<ShoppingListCheckedFoodListItem>;
  constructor() {
    this.uncheckedFoods = [];
    this.checkedFoods = [];
  }
}

// 買い物リスト登録の一要素
export class ShoppingListRegistFoodListItem {
  foodId: number | null | undefined;  // レシピサーバ食材ID、存在しない場合は、検索時の文字列を登録する場合
  tagIds: string | null | undefined;
  name: string;
  quantity: number | null | undefined;
  pantryId:  number | null | undefined;
  pantryPlateId: number | null | undefined;
  pantryFridgeId: number | null | undefined;
  constructor() {
    this.foodId = null;
    this.tagIds = null;
    this.name = "";
    this.quantity = null;
    this.pantryId = null;
    this.pantryPlateId = null;
    this.pantryFridgeId = null;
  }
}

// 買い物リスト登録
export class ShoppingListRegistFoodList {
  foods: Array<ShoppingListRegistFoodListItem>;
  constructor() {
    this.foods = [];
  }
}

// 買い物リスト登録のレスポンス
export class ShoppingListRegistResult {
  lastUpdated: string;
  foods: Array<ShoppingListRegistFoodListItem>;
  constructor() {
    this.lastUpdated = "";
    this.foods = [];
  }
}

// 買い物リストの更新一要素
export interface ShoppoingListUpdateItem {
  id: number;
  isChecked: boolean;
}

//買い物リストからの削除
export class ShoppingListDeleteFoodList {
  foodsIds: Array<number>;
  constructor() {
    this.foodsIds = [];
  }
}

// チェック済み買い物リストクリア
export interface ShoppingListClearResult {
  pantryLastUpdated: string;
  shoppingLastUpdated: string;
}

// 食品提案API
export interface ShoppingListFoodRecommendationReasonContentItem {
  type: string | null;
  id: number | null;
  image: string | null;
  url: string | null;
}
export interface ShoppingListFoodRecommendationsReasonItem {
  title: string;
  description: string;
  contents: Array<ShoppingListFoodRecommendationReasonContentItem>;
}
export interface ShoppingListFoodRecommendationsListItem {
  foodId: number;    
  name: string;
  image: string | null;
  icon: string | null;
  elapsedDays: number | null;
  reason: ShoppingListFoodRecommendationsReasonItem;
}
export class ShoppingListFoodRecommendationsList {
  foods: Array<ShoppingListFoodRecommendationsListItem> | null;
  recommendId: string;
  recommendTime: string;
  constructor() {
    this.foods = [];
    this.recommendId = "";
    this.recommendTime = "";
  }
}

// 消費済み
export interface ShoppingListPantryItemsConsumeFoodListItem {
  pantryId: number;
  pantryPlateId: number | null | undefined;
  pantryFridgeId: number | null | undefined;
  ingredientId: number;
  name: string;
  imageUrl: string | null | undefined;
}
export class ShoppingListPantryItemsConsumeFoodList {
  pantryList: Array<ShoppingListPantryItemsConsumeFoodListItem>;
  totalCount: number;
  start: number;
  constructor() {
    this.pantryList = [];
    this.totalCount = 0;
    this.start = 0;
  }
}

// よく使う食材
export interface ShoppingListRankingFoodListItem {
  rank:	number;
  foodId: number;
  category: string | null | undefined;
  name: string;
  image: string | null | undefined;
  icon: string | null | undefined;
}

export class ShoppingListRankingFoodList {
  foods: Array<ShoppingListRankingFoodListItem>;
  constructor() {
    this.foods = [];
  }
}

// お気に入り食品(一覧取得)
export interface ShoppingListFavoriteFoodListItem {
  foodId: number;
  class: string | null | undefined;
  category: string | null | undefined;
  name: string;
  image: string | null | undefined;
  icon: string | null | undefined;
}
export class ShoppingListFavoriteFoodList {
  foods: Array<ShoppingListFavoriteFoodListItem>;
  totalCount: number | null;
  start: number | null;
  constructor() {
    this.foods = [];
    this.totalCount = 0;
    this.start = 0;
  }
}

// 食品検索
export interface ShoppingListSearchFoodResultListItemBalance {
  name: string;
  value: string;
  color: string;
}
export interface ShoppingListSearchFoodResultListItemFoodShelfLifeTips {
  image: string;
  description: string;
}
export interface ShoppingListSearchFoodResultListItemFoodShelfLife {
  tips: ShoppingListSearchFoodResultListItemFoodShelfLifeTips;
  image: string;
  description: string;
  shelfLife: number;
  shelfType: string | null;
  shelfTypeName: string | null;
  default: number | null;
}
export interface ShoppingListSearchFoodResultListItem {
  foodId: number;
  name: string;
  class: string;
  category: string;
  description: string;
  image: string | null;
  icon: string | null;
  balances: Array<ShoppingListSearchFoodResultListItemBalance>
  shelfLives: Array<ShoppingListSearchFoodResultListItemFoodShelfLife>;
  refIndexDef: number;
}
export class ShoppingListSearchFoodResultList {
  foods: Array<ShoppingListSearchFoodResultListItem>;
  totalCount: number | null;
  start: number | null;
  constructor() {
    this.foods = [];
    this.totalCount = 0;
    this.start = 0;
  }
}

// 買い物リストへの食材登録
export class ShoppingListRegistListItem {
  foodId: number | null;
  name: string | null;
  constructor(foodId: number | null, name: string | null) {
    this.foodId = foodId;
    this.name = name;
  }
}

// シーン別検索を行う際のカテゴリ一覧を取得するAPIのレスポンス
export interface ShoppingListSceneCategoryListChildrenItem {
  id: number;                   // 食品ID
  name: string;                 // カテゴリ注釈
  note: string | null;          // 紹介文
  icon: string | null;          //
  image: string | null;         // カテゴリ画像URL
  seo: string | null;           //        
  aliasName: string | null;     // エイリアス別名
  recipeCount: number | null;   // 下位カテゴリにて登録されているレシピ数(クエリパラメータにて指定された機器情報や環境変数等での公開年月日等も考慮されたレシピが対象)
                                // レシピ数のカウント方法は延べ数(積上げ)とし、複数のカテゴリに同一レシピの登録がある場合も複数カウントとする
                                // ※sceneがofferでない場合は、固定でnullとなる
  startDate: string | null;     // example: 2020-12-04
  endDate: string | null;       // example: 2020-12-04
  isNew: boolean | null;        // カテゴリ・カテゴリ内のレシピに公開日が一カ月以内のデータが存在するかどうか
                                // 新着判定となるレシピがなく、カテゴリの公開日が設定されていない場合は、falseとなる
                                // ※sceneがofferでない場合は、固定でnullとなる
  releaseDate: string | null;   // レシピの公開日時 pattern: YYYY-MM-DDThh:mm:ss+09:00
  children: Array<ShoppingListSceneCategoryList>;
}
export interface ShoppingListSceneCategoryListSecondLevelItem {
  id: number;                   // 食品ID
  name: string;                 // カテゴリ名
  icon: string | null;          // カテゴリ・アイコンURL
  seo: string | null;           // 
  startDate: string | null;     // example: 2020-12-04
  endDate: string | null;       // example: 2020-12-04
  children: Array<ShoppingListSceneCategoryListChildrenItem>;
}
export interface ShoppingListSceneCategoryListFirstLevelItem {
  id: number;                   // 食品ID
  name: string;                 // カテゴリ名
  icon: string | null;          // カテゴリ・アイコンURL
  seo: string | null;           // 
  startDate: string | null;     // example: 2020-12-04
  endDate: string | null;       // example: 2020-12-04
  children: Array<ShoppingListSceneCategoryListSecondLevelItem>;
}
export class ShoppingListSceneCategoryList {
  categories: Array<ShoppingListSceneCategoryListFirstLevelItem>;

  constructor() {
    this.categories = [];
  }
}

//
// 内部で使用する型
//

// カテゴリの検索に使用
export interface ShoppingListCategorySeachParameter {
  index: number;
  categoryName: string;
}

// 関連レシピ
export interface ShoppingListItemRelatedRecipeItem {
  recipeId: number;
  title: string;
  imageUrl: string;
  servings: number;
}

// 食材情報
export interface ShoppingListIngredientListItem {
  ingredientName: string;
  ingredientId: number;
  quantity: string;
  isChecked: boolean;
  hasStock: boolean;
  relatedRecipes: Array<ShoppingListItemRelatedRecipeItem>;
}

// 食材一覧
export class ShoppingListIngredientList {
  list: Array<ShoppingListIngredientListItem>;

  constructor() {
    this.list = [];
  }
}

// カテゴリ毎の食材一覧
export class ShoppingListCategoryListItem {
  categoryName: string;
  foodList: Array<ShoppingListFoodListItem>;

  constructor() {
    this.categoryName = "";
    this.foodList = [];
  }
}

// カテゴリ一覧
export class ShoppingListCategoryList {
  list: Array<ShoppingListCategoryListItem>;

  constructor() {
    this.list = [];
  }
}

// レシピ情報
export interface ShoppingListTargetRecipeListItem {
  recipeId: number;
  title: string;
  imageUrl: string;
  servings: number;
}

// 食材のレシピ一覧
export class ShoppingListTargetRecipeList {
  list: Array<ShoppingListTargetRecipeListItem>;

  constructor() {
    this.list = [];
  }
}

// 検索で選択した食材
export class ShoppingListSelectSearchResult {
  id: number | null;
  name: string;

  constructor(id: number | null, name: string) {
    this.id = id;
    this.name = name;
  }
}

// 食品提案APIのパラメータ
export class ShoppingListRecommendationParameter {
  refresh: boolean;
  checkedIds: Array<number>;
  uncheckedIds: Array<number>;
  constructor() {
    this.refresh = false;
    this.checkedIds = [];
    this.uncheckedIds = [];
  }
}

// 食材追加で表示するカテゴリ
export class ShoppingListAppendFoodsCategoryListItem {
  index: number;
  categoryName: string;
  categoryData: ShoppingListSearchFoodResultList;
  constructor() {
    this.index = 0;
    this.categoryName = "";
    this.categoryData = new ShoppingListSearchFoodResultList();
  }
}
export class ShoppingListAppendFoodsCategoryList {
  list: Array<ShoppingListAppendFoodsCategoryListItem>;
  constructor() {
    this.list = [];
  }
}

// 食材追加内で仕様する構造
export interface ShoppingListAppendScreenListItem {
  foodId: number;
  name: string;
  imageUrl: string;
  check: boolean;
}
export class ShoppingListAppendScreenList {
  index: number;
  categoryName: string;
  foods: Array<ShoppingListAppendScreenListItem>;
  constructor() {
    this.index = 0;
    this.categoryName = "";
    this.foods = [];
  }
}
export class ShoppingListAppendScreenCategoryList {
  list: Array<ShoppingListAppendScreenList>;
  constructor() {
    this.list = [];
  }
}
export class ShoppingListChackedList {
  foodIds: Array<number>;
  constructor() {
    this.foodIds = [];
  }
}

// 食品提案バナーのインターフェース
export interface ShoppingListRecommendationBannerListItem {
  foodId: number;
  imageUrl: string;
  title: string;
  description: string;
  name: string;
  recipeIds: Array<number>;
}

export class ShoppingListRecommendationBannerList {
  list: Array<ShoppingListRecommendationBannerListItem>;
  constructor() {
    this.list = [];
  }
}

export interface ShoppingListSceneTopCategoryListItem {
  id: number;     // ID
  name: string;   // カテゴリ名
}

export class ShoppingListCategorySelectIngredientListItem {
  totalCount: number;
  list: Array<SelectingIngredientListDataItem> | null;

  constructor() {
    this.totalCount = 0;
    this.list = null;
  }
}

export class ShoppingListCategorySelectIngredientList {
  list: Array<ShoppingListCategorySelectIngredientListItem>;
  constructor() {
    this.list = [];
  }
}

export class ShoppingListAppendRegistingListItem {
  pageIndex: number;
  foodId: number | null;
  name: string;
  constructor(pageIndex: number, foodId: number | null, name: string) {
    this.pageIndex = pageIndex;
    this.foodId = foodId;
    this.name = name;
  }
}

// 買い物リストで保持するデータ
export interface ShoppingListState {
  foodList: ShoppingListFoodList | null;
  recommendList: ShoppingListFoodRecommendationsList | null;
  consumedList: ShoppingListPantryItemsConsumeFoodList | null;
  rankingList: ShoppingListRankingFoodList | null;
  favoriteList: ShoppingListFavoriteFoodList | null;
  sceneCategoryList: ShoppingListSceneCategoryList | null;
  chackedList: ShoppingListChackedList | null;
  registingFoodList: Array<ShoppingListAppendRegistingListItem> | null;
  searchResltList: ShoppingListSearchFoodResultList | null;
  registResultList: ShoppingListFoodList | null;
  previousSelectCategoryIndex: number;
  pantryList: PantryList | null;
}